import { SET_OFFERS_ORIGINAL, SET_OFFERS_FILTRADOS } from './action-types';

const setOffersOriginal = (payload) => ({ type: SET_OFFERS_ORIGINAL, payload });
const setOffersFiltrados = (payload) => ({ type: SET_OFFERS_FILTRADOS, payload });

export function SetOfertaOriginal(data) {
  return function action(dispatch) {
    return dispatch(setOffersOriginal(data));
  };
}
export function SetOfertaFiltrados(data) {
  return function action(dispatch) {
    return dispatch(setOffersFiltrados(data));
  };
}
